/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import React from 'react';
import {fetchFeed} from '../apiFunctions';
import T from 'i18n-react';
// import MDSpinner from "react-md-spinner";
import Infobox from "./infobox.jsx";
import {setFocusedPuff} from '../actions/puff';
import { connect } from 'react-redux';
import Card from './puff/card.jsx';
import Login from './modal/login.jsx';
import {browserHistory} from 'react-router';
import TT from './modal/tt.jsx';

class Magazine extends React.Component {

  constructor(props){
    super(props);
    this.search = this.search.bind(this);
    this.state = {search:''}
  }

  setSearch(q){
    this.setState({search:q})
  }

  search(query, page, e){
    if(e){
      e.preventDefault()
    }
    browserHistory.push({pathname: '/search', query:{q:query, view: page==='store' ? 'masonry' : 'magazine'}})
  }

  box(article, login){
    let {mobile, feed, myFeeds, user} = this.props
    let page = feed && feed.menu ? feed.menu.find(m=>m.type==='feed' && m.selected) : null
    page = page ? page.value : null
    let valid = this.state.search.length>1
    let message = {free:'AI written stories', store:'Search. Build. Publish.'}
    let access = !article.loggedIn && page==='store'
    if(article.hero){
      return <div key="herobox" style={{display:mobile ? null : 'grid'}}>
             
            <div className="thefont hero" style={{textAlign: mobile ? 'center' : undefined, fontSize: mobile ? '40pt' : undefined, display: mobile ? null : 'grid', gridTemplateColumns:'50% 50%', padding:50, background:page==='store' ? null : 'linear-gradient(183deg, #FF9800 50%, #f36f21 67%, rgb(181 63 63) 95%)'}}>
              <p style={{float:'left',margin:'auto auto 15px auto'}}>{message[page ? page : 'store']}</p>
              {mobile ? null : <img className="shadowed" src="/static/img/showcase.png" style={{ width:300,margin:'auto 0px -111px auto'}}/>}
              {access ? null : <form onSubmit={(e)=>valid ? this.search(this.state.search, page, e) : e.preventDefault()} style={{boxShadow: 'rgba(0, 0, 0, 0.62) 0px 2px 13px -6px', overflow:'hidden', borderRadius:30, height:50, position:'relative', maxWidth:500, minWidth:300, fontSize:'large', color:'black'}}>
                    <input style={{position:'absolute', left:0, width:'100%', height:'100%', border:'none', outline:'none', padding:'10px 100px 10px 20px'}} onChange={(e)=>this.setSearch(e.target.value)} value={this.state.search} placeholder="Search a story"/>
                    <TT text={valid ? null : 'You must type in a search term to proceed'}>
                      <span className={"button"} style={{backgroundColor:'white', color:'black',height:'100%',lineHeight:'30px',position:'absolute', right:0, fontSize: 'large', borderRadius:"0px 30px 30px 0px", margin:0, boxShadow:'none'}} 
                      onClick={()=>valid ? this.search(this.state.search) : null}>
                        <span style={{fontSize: 'larger', color:page === 'free' ? '#cd5236' : '#3777cd'}} className={"fa fa-"+(feed.isFetching ? "spinner fa-spin" : "search")} />
                      </span>
                    </TT>
              </form>}
             {!access ? null : <div style={{textAlign: '-webkit-center'}}>
                {mobile ? login : null}
                <p style={{fontSize: 'large'}}>Sign in to get access to the platform and start receiving SEO friendly News and blog Articles</p> 
                </div>}
            </div>
           
            </div>

    }else{
      return null
    }
  }
  
  showMore(topic, feed){
    if(topic.name==='headlines'){
      return
    } 
    let search = feed.id === 'search'
    let store = search && feed.menu.find(m=>m.type==='feed' && m.value==='store' && m.selected) 
    browserHistory.push({pathname: '/'+feed.id + (search ? '' : '/' + topic.name), query:{sort:'popular',q:(search ? topic.name: undefined), view:(search ? (store ? 'masonry' : 'magazine') : 'masonry' )}}) 
  }

  render() {
    let {feed, mobile, user, id} = this.props
    let placeholder = {filter: 'contrast(0)', opacity: 0.2} 
    let page = feed.menu ? feed.menu.find(m=>m.type==='feed' && m.selected) : null
    page = page ? page.value : null 
    let locked = !user && page==='store'
    let landing = feed.id==='search' && ((feed.info && feed.info.landing) || !feed.info || locked)
    let addingMoreCard = (feed.isFetching && feed.currentRequest &&  feed.currentRequest.offset<1)
    let topicsForFeed = feed.info && feed.info.topics ? feed.info.topics : null
    let widget = feed.info && feed.info.widget ? feed.info.widget : null
    let topics = []
    let cards = feed.puffs
    const noResultsFound = (feed && feed.lastRequest.query && feed.puffs.length===0 && !feed.isFetching)

    if(landing){
      topicsForFeed = !locked ? [{name:"welcome", visible:false}].concat(topicsForFeed).filter(t=>t) : [{name:"IT'S EASY",visible:false}]
      cards = !locked  ? [{hero:true, section:"welcome", loggedIn:user ? true : false}].concat(cards) : [{hero:true, section:"IT'S EASY", loggedIn:user ? true : false}]
    }

    let login = <Login redirect="search" style={{fontSize: 'initial', fontWeight: 'initial', color: 'initial', margin:(mobile ? '30px -40px' : '0px 15px 0px auto'),zIndex: 100}}/>

    if(topicsForFeed){
        let used = {}
    

        topicsForFeed.forEach((topic, topicIndex)=>{
          
          let selectedPuffs = cards.filter(puff=>(!used[puff.id] &&  puff.section===topic.name))
          
          if(selectedPuffs.length===0){
            return
          }

          let validVideo = (article)=>article.visualFocus && ((article.visualFocus.type === 'video' && article.visualFocus.sourceName && article.visualFocus.sourceName.toLowerCase()==='youtube') || (article.visualFocus.data && article.visualFocus.data[0] && article.visualFocus.data[0].lat && article.visualFocus.data[0].source!=='wikipedia'))
          let ytFirst = (a,b)=>validVideo(a) && !validVideo(b) ? -1 : (validVideo(b) && !validVideo(a) ? 1 : 0)
          // selectedPuffs = selectedPuffs.slice(0,topicIndex===0 ? 4 : 6).map((article,index, articles)=>{
          selectedPuffs = selectedPuffs.sort(ytFirst).map((article, index, articles)=>{

            if(article.hero){
              return null
            }

            let mainStory = topicIndex === 0 && index === 0 && articles.length>2

            let firstYTcard = !mobile && !mainStory && validVideo(article) && index === 0

            let keyId = id+ "-" + topic.name +"-topicpuffs-"+index;
            used[article.id] =true
            
            let cardStyle = addingMoreCard ? placeholder : {}
            let smallFeatured = (topicIndex !== 0 || mobile) && ((!landing || mobile) && articles.length>2 && articles.length<4)
            
            return <Card  small={articles.length>3} 
                          writeAccess={(feed.write || feed.id==='profile')} 
                          featured={smallFeatured || mainStory}
                          smallFeatured = {smallFeatured}
                          tabId={this.props.feed ? this.props.feed.id : null} 
                          single={false} 
                          user={this.props.user}
                          mobile={mobile} 
                          isMagazine={true} 
                          style={{...cardStyle,
                                  // ...(firstYTcard ? {gridArea:'1 / 1 / 3 / 2'} : {}),
                                   ...(mainStory ? 
                                  {gridRow: '1 / 6', gridColumn: (widget && !mobile) ? '1 / 3' : '1' } : 
                                  (mobile && articles.length>2 && articles.length<4 ? {display:'inline-table',width:'50vw',minWidth:200} : {})),
                                   ...(mainStory ? {fontSize:'22pt'} : {})
                                }} 
                          lFormatter={this.props.lFormatter} 
                          scrollId={this.props.id} 
                          scrollKey={keyId} 
                          key={keyId+"-"+article.id} 
                          id={keyId+"-"+article.id}  
                          article={article} />
          })
          topics.push({...topic, puffs:selectedPuffs})
        })    
    }

    // console.log(topics)
    return (

      <div style={{maxWidth:1170, margin:'auto', marginTop:0, width:'100%', marginBottom:100}}>
        {landing || (widget && mobile) ? null : <Infobox headerOnly={true} loading={feed.isFetching} feed={feed} info={feed.info}/>}
        {(!landing && widget && mobile) ? <Infobox small={false} info={feed.info} feed={feed}/> : null}
        {this.props.message ? this.props.message : null}
        {topicsForFeed ? 
          <div>
        
          {topics.map((topic,i)=>{
              
              let slider = topic.puffs.length > 2 && topic.puffs.length<4 && mobile
              let headlines = ['headlines', 'published'].includes(topic.name) && i===0

              return  <div key={this.props.id + 'magazineTopic-'+i} style={{paddingTop:i>0 ? 40 : 30}}>     
                          
                          {topic.visible===false ? null : 
                          <div style={{...(addingMoreCard ? placeholder : {}), display:'grid', gridTemplateColumns:'auto 100px', width:'100%', padding:'0px 25px', fontWeight:'bold', fontFamily: 'ubuntu, system-ui'}}>
                            <p style={{width:'fit-content', cursor:topic.name==='headlines' ? '' : 'pointer', fontSize:'18pt',textAlign:'left'}}>{topic.name.toUpperCase()}</p>
                            
                          </div>}
                        
                        <div style={{display: (slider ? 'flex' : (mobile ? null : 'grid')), 
                                    overflow:slider ? 'scroll' : null,
                                    columnGap: (widget && !mobile) && headlines ? 20 : 0,
                                    gridTemplateColumns: (mobile ? (topic.puffs.length > 2 && topic.puffs.length<3 ? 'auto auto' :'unset') : (headlines ? ((widget && !mobile) ? 'auto auto 300px' : 'auto 40%') : 'repeat(auto-fit, minmax(300px, 1fr))'))}}>
                          {topic.puffs}
                          {(widget && !mobile) && headlines ? <Infobox small={true} info={feed.info}/> : null}
                          {locked && !mobile ? login : null}
                        </div>
                      </div>
              })}
          </div>
        : null}
      </div>
 
    );
  }
}

 
const mapStateToProps = function(store) {
  return {
    selectedPuff: store.puff.selectedPuff
  };
};

export default connect(mapStateToProps)(Magazine);
